export default __webpack_public_path__ + "static/media/Abandoned_Icon.777fbb00.png";